import React from 'react'
import { withRouter } from 'react-router-dom'
import { changeLanguage } from 'i18next'
import { withTranslationCustom } from 'lib/i18next'
import classNames from 'classnames'
import cookies from 'lib/cookies'
import moment from 'moment'
import { languages } from 'i18n'
import { updatePathWithOrWithoutLangParam } from 'lib/helpers'
import { logException } from 'lib/errors'

import AppContext from 'components/AppContext'
import Button from 'components/UI/Button'
import FiFlagIcon from 'images/svg/icon/icon_flag_fi.svg'
import EnFlagIcon from 'images/svg/icon/icon_flag_en.svg'

class LanguageNavigation extends React.Component {
    handleLanguageChange = async (newLanguage) => {
        const { history, location } = this.props

        try {
            await changeLanguage(newLanguage)

            // Update path with or without language parameter
            const updatedPath = updatePathWithOrWithoutLangParam(newLanguage, location.pathname)
            let updateSearch = location.search

            if (location.search) {
                // Extract existing target parameter
                const urlParams = new URLSearchParams(location.search)
                const targetParam = urlParams.get('target')

                if (targetParam) {
                    // Replace '/en' with '' or add '/en' based on new language
                    const newTargetParam = newLanguage === 'fi' ? targetParam.replace('/en', '') : `/en${targetParam}`
                    urlParams.set('target', newTargetParam)
                    updateSearch = `?${urlParams.toString()}`
                }
            }

            // Set language cookie and update moment locale
            cookies.set('lang', newLanguage)
            moment.locale(newLanguage)
            history.push(updatedPath + updateSearch + location.hash, location.state)
        } catch (error) {
            logException('Error changing language: ', error)
        }
    }

    render () {
        const { i18n, icon = false } = this.props

        if (languages.length <= 1) return null

        return (
            <AppContext context="languageNavigation">
                <nav className="language-navigation">
                    {i18n.language === 'en' ? (
                        <Button
                            trackName="toggleLanguage"
                            trackLabel="fi"
                            className={classNames(['button', 'button--plain'])}
                            onClick={() => this.handleLanguageChange('fi')}
                        >
                            {icon && <FiFlagIcon />}
                            Suomeksi
                        </Button>
                    ) : (
                        <Button
                            trackName="toggleLanguage"
                            trackLabel="en"
                            className={classNames(['button', 'button--plain'])}
                            onClick={() => this.handleLanguageChange('en')}
                        >
                            {icon && <EnFlagIcon />}
                            In English
                        </Button>
                    )}
                </nav>
            </AppContext>
        )
    }
}

export default withRouter(withTranslationCustom()(LanguageNavigation))
